import React, { useState } from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import { SearchSelect } from 'lib';
import styles from './styles';

const DwlContactAdder = ({ classes, options, onSelect, className }) => {
  const [picks, setPicks] = useState(0);

  const handleSelect = (id) => {
    onSelect(id ?? '');
    setPicks((prev) => prev + 1);
  };

  return (
    <div className={classnames(classes.wrapper, className)}>
      <InputLabel className={classes.label}>Contacts List</InputLabel>
      <SearchSelect
        // remounting empties the input: this field adds contacts, it never holds one
        key={picks}
        value={null}
        onChange={handleSelect}
        options={options || []}
        getOptionLabel={(user) => user?.profile?.fullName || user?.username || ''}
        inputProps={{
          id: 'dwlVerificationContactsSelector',
          placeholder: options?.length ? '+ Select Contact' : 'No options available',
        }}
      />
    </div>
  );
};

DwlContactAdder.propTypes = {
  classes: propTypes.object.isRequired,
  options: propTypes.array,
  onSelect: propTypes.func.isRequired,
  className: propTypes.string,
};

DwlContactAdder.defaultProps = {
  options: [],
  className: undefined,
};

export default withStyles(styles)(DwlContactAdder);
